export enum RoutesPaths {
    Home = '/',
    Login = '/login',
    LoginAlternative = '/login/alternativo',
    PermissionDenied = '/permission-denied',
    Settings = '/settings',
    Operations = '/operations',
}
